export * from './attributes'
export * from './answer-option.serializer'
export * from './app-package.serializer'
export * from './phone_control.serializer'
export * from './base.serializer'
export * from './center-program.serializer'
export * from './center-repeat-exam-setting.serializer'
export * from './center.serializer'
export * from './city.serializer'
export * from './country.serializer'
export * from './course.serializer'
export * from './courses-group.serializer'
export * from './device-activation.serializer'
export * from './driver.serializer'
export * from './exam-section.serializer'
export * from './exam-result.serializer'
export * from './exam.serializer'
export * from './interactive-content-item.serializer'
export * from './interactive-content-item-transition-skill.serializer'
export * from './interactive-content-item-transition.serializer'
export * from './interactive-skill.serializer'
export * from './interactive-skill-grade.serializer'
export * from './interactive.serializer'
export * from './folder.serializer'
export * from './infraction.serializer'
export * from './accessor-infraction.serializer'
export * from './moderated-infraction.serializer'
export * from './lesson-quiz-question.serializer'
export * from './lesson-quiz.serializer'
export * from './lesson-text.serializer'
export * from './lesson.serializer'
export * from './photo.serializer'
export * from './program.serializer'
export * from './question.serializer'
export * from './session-infraction.serializer'
export * from './session-interactive.serializer'
export * from './session-interactive-skill-grade.serializer'
export * from './session-version.serializer'
export * from './session.serializer'
export * from './skill.serializer'
export * from './start-exam-config.serializer'
export * from './static-screen.serializer'
export * from './system-screen.serializer'
export * from './user.serializer'
export * from './video.serializer'
export * from './audio.serializer'
export * from './speech.serializer'
export * from './document.serializer'
export * from './driver-license.serializer'
export * from './motivation-video.serializer'
export * from './exams/section.serializer'
export * from './api-key.serializer'
export * from './app-locale.serializer'
export * from './app-translation.serializer'
export * from './ab-test.serializer'
export * from './ab-test-program.serializer'
export * from './exam-registration.serializer'
export * from './online-session.serializer'
export * from './user-shift-settings.serializer'
export * from './interview.serializer'
export * from './comment.serializer'
export * from './hub.serializer'
export * from './hub-course.serializer'
export * from './hub-course-timetable.serializer'
export * from './hub-course-premoderation.serializer'
export * from './hub-week-day.serializer'
export * from './hub-time-interval.serializer'
export * from './hub-registration.serializer'
export * from './hub-stop.serializer'
export * from './hub-course-stop.serializer'
export * from './user-permission.serializer'
export * from './export-result.serializeer'
export * from './ab-experinent.serializer'
export * from './slot-subscription.serializer'
export * from './attachment.serializer'
export * from "./online-interviewer-schedule/online-interviewer-schedule.serializer"
export * from "./online-interviewer-schedule/online-interviewer-schedule-period.serializer"
export * from "./online-interviewer-schedule/online-interviewer-schedule-shift.serializer"
export * from "./online-interviewer-schedule/interviewer.serializer"
export * from "./report.serializer"
export * from "./sms-template.serializer"
export * from "./briefing.serializer"
export * from "./briefing-registration.serializer"
export * from './notification.serializer'
export * from "./cancellation-reason.serializer"
export * from './online-learning-registration.serializer'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/index.ts